import React from "react";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import Loading from "../../Loading";
import { renderPrice, timeSince } from "../../../Utils/functions";
import { Link } from "react-router-dom";
const ProductCard = ({ loading, data = {} }) => {
  let check = () => {
    let res = false;
    data?.options?.map(op => {
      if (op.id == 1) {
        res = true;
      }
    });
    return res;
  };
  const render = () => {
    if (data.price) {
      if (data.price == "0") {
        return "قیمت : به صورت توافقی";
      } else {
        return `قیمت : ${renderPrice(data.price)}`;
      }
    }
    return "قیمت : به صورت توافقی";
  };

  return (
    <>
      <Link
        className="product-card"
        to={`/ads/${data?.city?.slug}/${data.slug}`}
      >
        <div className="img-card">
          <img src={data?.main_image?.url} alt={data?.main_image?.alt} />
        </div>
        <div className="content-card">
          <h4 className="head-2 text-center">{data.title}</h4>
          {check() && (
            <div className="accept">
              <MdOutlineVerifiedUser className="primary-color" />
              <p className="">آگهی های تایید شده</p>
            </div>
          )}

          <div className="icon-label mt-10 mb-7">
            <IoLocationSharp />
            <p>{`${data?.province?.title ?? ""}، ${data?.city?.title ?? ""
              }`}</p>
          </div>
          <div className="icon-label mb-12">
            <FaUser />
            {console.log(data)}
            <p>{data?.contacts_data?.fullname || data?.contacts_data?.co_name || data?.client?.fullname}</p>
          </div>
          <div className="time-label ">
            <span>{timeSince(data.updated_at)}</span>
          </div>
        </div>
        <div className="footer-card">
          <button className="primary-btn">{render()}</button>
        </div>
      </Link>
    </>
  );
};

export default ProductCard;
